import { Injectable } from '@angular/core';
import { Store } from '../store';
import { NotificationService } from './notification.service';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class MenuService {
    body = document.getElementsByTagName('body')[0];

    constructor(
        private store: Store,
        private notificationService: NotificationService,
        private router: Router
    ) {}

    close() {
        this.store.set('menuOpen', false);
        this.body.classList.remove('body-freeze');
    }

    toggle() {
        let m = this.store.selectForLocal('menuOpen');
        if (m) {
            m = false;
            this.body.classList.remove('body-freeze');
        } else {
            m = true;
            this.body.classList.add('body-freeze');
        }
        this.store.set('menuOpen', m);
    }

    setHeader(navItem) {
        this.store.set('headerContent', navItem);
    }

    clearHeader() {
        const headerContent = undefined;
        this.store.set('headerContent', headerContent);
    }

    setActiveMenu(group, url, subItem?) {
        this.store.set('activeMenuItem', { group, url, subItem });
    }

    locateMenuItem(r) {
        const menuItems = this.store.selectForLocal('menuItems');
        for (let m = 0; m < menuItems.length; m++) {
            if (menuItems[m].route === r) {
                return menuItems[m];
            }
            for (let sm = 0; sm < menuItems[m].subMenus.length; sm++) {
                if (menuItems[m].subMenus[sm].route === r) {
                    return menuItems[m].subMenus[sm];
                }
            }
        }
    }

    get sidebarOpened(): boolean
    {
        return this.store.selectForLocal('isSideBarOpen');
    }

    set sidebarOpened(isSideBarOpen: boolean)
    {
        this.store.set('isSideBarOpen', isSideBarOpen);
    }

    setDomain(domainId) {
        this.store.set('domain', domainId);
        localStorage.setItem('activeDomain', domainId);
        this.notificationService.getUnfilteredNotifications().subscribe();
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/dashboard']));
    }
}
